import { render, staticRenderFns } from "./SberIdCallback.vue?vue&type=template&id=4d8d4b6d&"
import script from "./SberIdCallback.vue?vue&type=script&lang=js&"
export * from "./SberIdCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports